import { Microphone, Stop } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";

interface RecordingControlsProps {
  isRecording: boolean;
  hasAudio: boolean;
  onStartRecording: () => void;
  onStopRecording: () => void;
}

export default function RecordingControls({
  isRecording,
  hasAudio,
  onStartRecording,
  onStopRecording,
}: RecordingControlsProps) {
  return (
    <>
      {/* Start recording button */}
      {!hasAudio && !isRecording && (
        <Button
          size="sm"
          intent="iconOnly"
          variant="default-purple"
          onClick={onStartRecording}
          aria-label="Start recording"
        >
          <Microphone weight="fill" />
        </Button>
      )}

      {/* Stop recording button */}
      {isRecording && (
        <Button
          size="sm"
          intent="iconOnly"
          variant="secondary-purple"
          onClick={onStopRecording}
          aria-label="Stop recording"
        >
          <Stop weight="fill" />
        </Button>
      )}
    </>
  );
}
